<div class="row" style="padding: 20px;">
    <div class="d-flex justify-content-between align-items-center">
        <h2>Create account</h2>
        <button mat-raised-button color="secondary" (click)="backClicked()">Back</button>
    </div>
    <button-scroll-to-top />
    <form [formGroup]="createAccountForm" class="mt-4">
        <div class="container-fluid">
            <div class="row g-3">
                <div class="col-12 col-md-6 col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Email</mat-label>
                        <input type="text" matInput formControlName="email" />
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Password</mat-label>
                        <input type="text" matInput formControlName="password" />
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Role</mat-label>
                        <mat-select formControlName="role_id">
                            <mat-option style="background-color: white;">
                                <ngx-mat-select-search [formControl]="rolesFilter" placeholderLabel="Search roles"
                                    noEntriesFoundLabel="'no matching roles found'" />
                            </mat-option>
                            <mat-option *ngFor="let role of filteredRoles | async" [value]="role.id">
                                {{ role.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Full name</mat-label>
                        <input type="text" matInput formControlName="full_name" />
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Position</mat-label>
                        <mat-select formControlName="position">
                            <mat-option>None</mat-option>
                            <mat-option style="background-color: white;">
                                <ngx-mat-select-search [formControl]="positionsFilter"
                                    placeholderLabel="Search positions"
                                    noEntriesFoundLabel="'no matching positions found'" />
                            </mat-option>
                            <mat-option *ngFor="let position of filteredPositions | async" [value]="position.id">
                                {{ position.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>ZOHO user</mat-label>
                        <mat-select formControlName="zoho_owner_id">
                            <mat-option>None</mat-option>
                            <mat-option style="background-color: white;">
                                <ngx-mat-select-search [formControl]="usersFilter" placeholderLabel="Search users"
                                    noEntriesFoundLabel="'no matching users found'" />
                            </mat-option>
                            <mat-option *ngFor="let user of filteredUsers | async" [value]="user.id">
                                {{ user.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Extension</mat-label>
                        <input type="tel" matInput formControlName="extension" />
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Company</mat-label>
                        <mat-select (selectionChange)="onCompanyChanged($event.value)" formControlName="company_id">
                            <mat-option>None</mat-option>
                            <mat-option style="background-color: white;">
                                <ngx-mat-select-search [formControl]="companiesFilter"
                                    placeholderLabel="Search companies"
                                    noEntriesFoundLabel="'no matching companies found'" />
                            </mat-option>
                            <mat-option *ngFor="let company of filteredCompanies | async" [value]="company.id">
                                {{ company.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Department</mat-label>
                        <mat-select formControlName="department_id">
                            <mat-option>None</mat-option>
                            <mat-option style="background-color: white;">
                                <ngx-mat-select-search [formControl]="departmentsFilter"
                                    placeholderLabel="Search departments"
                                    noEntriesFoundLabel="'no matching departments found'" />
                            </mat-option>
                            <mat-option *ngFor="let department of filteredDepartments | async" [value]="department.id">
                                {{ department.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <mat-slide-toggle formControlName="create_rapid">Create Rapid Account</mat-slide-toggle>
                </div>
            </div>
        </div>
        <hr class="my-4">
        <div class="d-flex gap-2 flex-wrap">
            <button mat-raised-button color="primary" [disabled]="createAccountForm.invalid"
                (click)="createAccount()">Save
            </button>
        </div>
    </form>
</div>